import React from 'react';
import styles from './AdminMobileStartPage.module.css';
import { mainColor } from 'routes/adminMobile/constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import mainLogo from 'routes/vendorRe/images/main_logo.png';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';

const AdminMobileStartPage = () => {
    const { moveToHome } = useCustomAdminMobileMove();

    return (
        <Container height="100vh" backgroundColor={mainColor}>
            <VerticalFlex gap="2vh">
                <FlexChild justifyContent="flex-end">
                    <img
                        className={styles.logoImg}
                        src={mainLogo}
                        alt="PUFFU 로고"
                        onClick={() => moveToHome()}
                    />
                </FlexChild>
                <FlexChild>
                    <span className={styles.logoTxt}>본사 관리자용</span>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileStartPage;
